// extracted by mini-css-extract-plugin
export default {"heading_text":"events_past_line_uncompleted_heading_text__alV2D"};